import api from "../apiConfig";
import paramsFactory from "../../utils/paramsFactory";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  index(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/ticket-project?${p}`);
  },
  showById(id) {
    return api.get(`/api/v1/ticket-project/${id}`);
  },
  create(data) {
    return api.post(`/api/v1/ticket-project`, data);
  },
  update(id, data) {
    return api.put(`/api/v1/ticket-project/${id}`, data);
  },
  delete(id) {
    return api.delete(`/api/v1/ticket-project/${id}`);
  },
};
